export default class SegcontrolGroupController {
  constructor($scope) {
    'ngInject'
    this._$scope = $scope
  }

  $onInit() {
    // Re-define $render
    this.ngModelCtrl.$render = () =>
      this.ngModelCtrl.$setViewValue(this.ngModelCtrl.$viewValue)

    // Set a watch to run render if any changes to the model occur outside of the component
    this._$scope.$watch(
      () => this.ngModelCtrl.$viewValue,
      () => {
        this.ngModelCtrl.$render()
      }
    )
  }
}
